<template>
    <div>
        <AppBar :backBtn="{ visible: true, backTo: backTo }" :navTab="false" :actionBtns="{ visible: false }">
            <template #title>Audit Trail Information</template>
        </AppBar>
        <v-form ref="formData" class="form-data">
            <v-container fluid class="pa-5" id="">
                <v-row>
                    <v-col cols="12" md="12" class="px-8 pt-8 pb-0">
                        <div class="card px-8 pt-5 pb-6 white rounded-lg">
                            <v-row>
                                <v-col cols="12" md="4" class="form-detail">
                                    <div>Name</div>
                                    <div>{{ actorName }}</div>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <div>Role</div>
                                    <div>{{ auditTrail.actor_role_name }}</div>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <div>Email</div>
                                    <div>{{ (auditTrail.actor || {}).email }}</div>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <div>Mobile Number</div>
                                    <div>{{ (auditTrail.actor || {}).mobile }}</div>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <template>
                                        <div>Company</div>
                                        <div>{{ auditTrail.company }}</div>
                                    </template>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <template>
                                        <div>Remarks</div>
                                        <div>{{ auditTrail.remarks }}</div>
                                    </template>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <template>
                                        <div>Action</div>
                                        <div>{{ auditTrail.action }}</div>
                                    </template>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <template>
                                        <div>Module</div>
                                        <div>{{ auditTrail.object_type }}</div>
                                    </template>
                                </v-col>

                                <v-col cols="12" md="4" class="form-detail">
                                    <div>Date & Time Logged</div>
                                    <div>{{ auditTrail.logged_at | moment('MMM DD, YYYY HH:mm:ss') }}</div>
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';

export default {
    name: 'AuditTrailsDetails',
    components: { AppBar },
    data() {
        return {
            backTo: '/audit-trails',
            is_active: true,
            form: {}
        };
    },
    created() {
        this.getData();
    },
    computed: {
        auditTrail() {
            const data = this.$store.getters['auditTrails/getAuditTrail'];
            return data || { actor: {} };
        },
        actorName() {
            if (!this.auditTrail.actor) {
                return '';
            }

            return this.auditTrail.actor.first_name + ' ' + this.auditTrail.actor.last_name;
        }
    },
    methods: {
        getData() {
            this.setIsBusy(true);

            this.$store
                .dispatch('auditTrails/findAuditTrail', {
                    id: this.$route.params.id,
                    config: {
                        params: {
                            appends: ['actor', 'actor_role_name']
                        }
                    }
                })
                .then(() => {
                    //this.form = response.data;
                    this.setIsBusy(false);
                })
                .catch(() => {
                    this.setIsBusy(false);
                });
        }
    }
};
</script>

<style lang="scss" scoped></style>
